var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4997 0.505249C4.70397 0.505249 0.00488281 5.20603 0.00488281 11C0.00488281 16.7974 4.70397 21.4948 10.4997 21.4948C16.2954 21.4948 20.9945 16.7974 20.9945 11C20.9945 5.20603 16.2954 0.505249 10.4997 0.505249ZM10.4997 5.1602C11.4813 5.1602 12.277 5.95594 12.277 6.93754C12.277 7.91914 11.4813 8.71488 10.4997 8.71488C9.51807 8.71488 8.72233 7.91914 8.72233 6.93754C8.72233 5.95594 9.51807 5.1602 10.4997 5.1602ZM12.3617 16.4167C12.6421 16.4167 12.8695 16.1893 12.8695 15.9089V14.8933C12.8695 14.6128 12.6421 14.3855 12.3617 14.3855H11.8538V10.1537C11.8538 9.87325 11.6265 9.64587 11.346 9.64587H8.6377C8.35726 9.64587 8.12988 9.87325 8.12988 10.1537V11.1693C8.12988 11.4498 8.35726 11.6771 8.6377 11.6771H9.14551V14.3855H8.6377C8.35726 14.3855 8.12988 14.6128 8.12988 14.8933V15.9089C8.12988 16.1893 8.35726 16.4167 8.6377 16.4167H12.3617Z",
    fill: "#2E73DC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-icon.b842a5fb9a64c8fdcd3bcb6fe30cd715.svg";